import { strikeThroughPlugin, strikeThroughMark } from "./strikeThroughMark.js";
import { createMarkHtmlDeserializer } from "../../../baseEditor/CustomMarkPlugin.js";
const withStrikeThrough = (editor) => {
  editor.registerMark(strikeThroughPlugin);
  editor.htmlDeserializer.registerPlugin(
    createMarkHtmlDeserializer(
      strikeThroughMark,
      (el) => el.nodeName === "S",
      (el) => el.style.textDecoration === "line-through"
    )
  );
  return editor;
};
export {
  withStrikeThrough
};
//# sourceMappingURL=withStrikeThrough.js.map
